import { useStaffChannelFlag } from "./flag";

/**
 * Mục "Kênh nhân sự" hiện khi máy chủ nói màn mở cho chính người này (luồng
 * kenh_nhan_su bật, và có tên trong danh sách mở thử nếu đang mở thử). Không
 * có quyền riêng: mọi nhân sự còn làm đều dùng được (CEO 1a, 16/10/2026).
 */
export function showStaffChannelInMenu(): boolean {
  return useStaffChannelFlag.getState().enabled;
}
